import qs from 'querystring';

let _iosCookieHeader = null;

export function setIosCookies(cookieString) {
  _iosCookieHeader = cookieString;
}

export function clearIosCookies() {
  _iosCookieHeader = null;
}

export default function HTTPService() {
  const HTTP_METHOD_GET = 'GET';
  const HTTP_METHOD_POST = 'POST';
  const HTTP_METHOD_DELETE = 'DELETE';
  const HTTP_METHOD_PATCH = 'PATCH';
  const HTTP_HEADER_ACCEPT = 'Accept';
  const HTTP_HEADER_CONTENT_TYPE = 'Content-Type';
  const HTTP_CREDENTIALS = 'credentials';
  const HTTP_CREDENTIALS_TYPE = 'include';

  const MIME_TYPE_JSON = 'application/json;charset=utf-8';

  return {
    getAuthenticated,
    postAuthenticated,
    deleteAuthenticated,
    patchAuthenticated,
    getJwtAuthenticated,
  };

  function getAuthenticated({
    url,
    query,
    headers,
    signal,
    responseType,
    withIosCookies,
  }) {
    return makeRequest({
      method: HTTP_METHOD_GET,
      url,
      query,
      headers,
      signal,
      responseType,
      withIosCookies,
    });
  }

  function postAuthenticated({ url, body, query, responseType, withIosCookies }) {
    return makeRequest({
      method: HTTP_METHOD_POST,
      url,
      body,
      query,
      responseType,
      withIosCookies,
    });
  }

  function deleteAuthenticated({ url, body, query, withIosCookies }) {
    return makeRequest({
      method: HTTP_METHOD_DELETE,
      url,
      body,
      query,
      withIosCookies,
    });
  }

  function patchAuthenticated({ url, query, withIosCookies }) {
    return makeRequest({
      method: HTTP_METHOD_PATCH,
      url,
      query,
      withIosCookies,
    });
  }

  function getJwtAuthenticated({ url, path, store, overUser, overPass }) {
    // request for credentials
    let authBody = {
      username: overUser,
      password: overPass,
    };
    let authFunc = function () {
      return fetch(url + '/api/token', {
        method: HTTP_METHOD_POST,
        body: JSON.stringify(authBody),
        headers: new Headers({
          Accept: 'application/json;charset=utf-8',
          'Content-Type': 'application/json;charset=utf-8',
        }),
      })
        .catch(error => console.log(error))
        .then(r => {
          return r.json();
        });
    };

    return authFunc().then(r => {
      let headers = {
        Authorization: `jwt ${r.access_token}`,
      };
      let query = {
        store: store,
      };
      return makeRequest({
        method: HTTP_METHOD_GET,
        url: url + path,
        query: query,
        headers: headers,
      });
    });
  }

  async function makeRequest({
    method,
    url,
    query = {},
    body = {},
    headers = {},
    signal,
    responseType,
    // Opt-in, not inferred from `url`: only services that need Heimdal's
    // session cookie on iOS pass this.
    withIosCookies = false,
  }) {
    const finalUrl =
      query && Object.keys(query).length
        ? `${url}?${qs.stringify(query)}`
        : url;

    const mergedHeaders = { ...headers };
    if (withIosCookies && _iosCookieHeader && !mergedHeaders.Cookie) {
      mergedHeaders.Cookie = _iosCookieHeader;
    }

    const finalHeaders = Object.keys(mergedHeaders).reduce((acc, headerKey) => {
      acc.append(headerKey, mergedHeaders[headerKey]);
      return acc;
    }, new Headers());

    finalHeaders.set(HTTP_HEADER_ACCEPT, MIME_TYPE_JSON);

    const isFormData = body instanceof FormData;
    if (method === HTTP_METHOD_POST && !isFormData) {
      finalHeaders.set(HTTP_HEADER_CONTENT_TYPE, MIME_TYPE_JSON);
    }
    const requestDescription =
      method === HTTP_METHOD_POST
        ? {
          method,
          headers: finalHeaders,
          body: isFormData ? body : JSON.stringify(body),
          [HTTP_CREDENTIALS]: HTTP_CREDENTIALS_TYPE,
          ...(signal ? { signal } : {}),
        }
        : {
          method,
          headers: finalHeaders,
          [HTTP_CREDENTIALS]: HTTP_CREDENTIALS_TYPE,
          ...(signal ? { signal } : {}),
        };

    const response = await fetch(finalUrl, requestDescription);

    if (responseType === 'blob') {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.blob();
    }

    const responseText = await response.text();
    let responseBody = {};
    try {
      responseBody = JSON.parse(responseText);
    } catch (error) {
      // Response is not JSON
    }

    if (response.ok) {
      if (Array.isArray(responseBody) || (responseBody && Object.keys(responseBody).length > 0)) {
        return responseBody;
      } else {
        return responseText;
      }
    } else if (responseBody?.message) {
      return { ...responseBody, status: response.status };
    } else {
      throw new Error(responseText || `HTTP ${response.status}`);
    }
  }
}
